import type { ComponentType, ReactNode } from "react";

export default function Providers({
  children,
  providers,
}: {
  children: ReactNode;
  providers: {
    key: string;
    Component: ComponentType<{ children: ReactNode }>;
  }[];
}) {
  return providers.reduceRight(
    (acc, provider) => (
      <provider.Component key={provider.key}>{acc}</provider.Component>
    ),
    children,
  );
}
